var exports = {
  "kL": "xa15a2ab7--14d152--container",
  "Sl": "xa15a2ab7--14d152--image",
  "DD": "xa15a2ab7--14d152--title",
};

module.exports = exports;
